module.exports = __webpack_public_path__ + "static/media/licensePlate.55ffe444.svg";